import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPrice = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-brand-bg-cream overflow-hidden" data-id="element-59">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20" data-id="element-60">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12" data-id="element-61">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left z-10 flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-62">
            <div className="order-1 inline-flex flex-col items-center lg:items-start mb-4 sm:mb-6" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/xe5FHGZsAmGh5FFq7msfu2/imagen_calificacion.png" alt="5 estrellas de calificación" className="h-14 sm:h-16 object-contain mb-2" data-id="element-64" />
              <span className="text-sm font-medium text-brand-text-medium" data-id="element-65">
                +300 mujeres con SIBO ya lo están usando
              </span>
            </div>

            <h1 className="order-2 text-[2.5rem] sm:text-5xl lg:text-[3.5rem] xl:text-6xl font-playfair font-bold text-brand-text-dark leading-tight mb-4 sm:mb-6" data-id="element-66">
              Volvé a comer{' '}
              <span className="text-brand-green italic" data-id="element-67">sin dolor</span> en solo{' '}
              <span className="text-brand-accent-orange" data-id="element-68">21 días</span>
            </h1>

            <p className="order-3 text-lg sm:text-xl font-medium text-brand-text-medium mb-6 sm:mb-8 max-w-2xl mx-auto lg:mx-0 font-inter" data-id="element-69">
              Dejá de sentirte inflamada después de cada comida con un plan
              claro y práctico
            </p>

            {/* Mobile Image */}
            <motion.div className="order-4 block lg:hidden w-full max-w-md mx-auto relative mb-8" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-70">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-71">
                <img src="https://cdn.magicpatterns.com/uploads/cXyoe3csWyLQG4FKbaHHxp/hero.png" alt="Mujer con molestia digestiva" className="w-full h-auto object-cover" data-id="element-72" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-bg-cream/30 to-transparent pointer-events-none" data-id="element-73"></div>
              </div>
              <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-green-lighter/15 rounded-full blur-3xl" data-id="element-74"></div>
            </motion.div>

            <ul className="order-5 flex flex-col gap-3 sm:gap-4 mb-8 sm:mb-10 text-left max-w-md mx-auto lg:mx-0" data-id="element-75">
              {['Sin dietas imposibles', 'Sin dejar de comer rico', 'Sin sentirte perdida'].map((item, index) => <motion.li key={index} className="flex items-center gap-3 text-brand-text-dark font-semibold text-base sm:text-lg" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} data-id="element-76">
                  <div className="bg-brand-green p-1.5 rounded-full" data-id="element-77">
                    <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-78" />
                  </div>
                  {item}
                </motion.li>)}
            </ul>

            <motion.button onClick={scrollToPrice} className="order-6 w-full sm:w-auto bg-brand-accent-orange hover:bg-[#c27622] text-white font-poppins font-bold text-xl py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-79">
              QUIERO EMPEZAR AHORA
            </motion.button>
          </motion.div>

          {/* Desktop Image */}
          <motion.div className="hidden lg:block flex-1 w-full max-w-lg lg:max-w-none relative" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-80">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/cXyoe3csWyLQG4FKbaHHxp/hero.png" alt="Mujer con molestia digestiva" className="w-full h-auto object-cover" data-id="element-82" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-bg-cream/30 to-transparent pointer-events-none" data-id="element-83"></div>
            </div>
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-green-lighter/15 rounded-full blur-3xl" data-id="element-84"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}